module.exports = __webpack_public_path__ + "static/WTC.nl-046694b0789960a3c0c786caf5e91e5d.svg";